// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const audioProgress = (data: any) => ({
  event: 'audioProgress',
  timestamp: Math.floor(Date.now() / 1000),
  content: {
    audio: {
      name: data.name || '',
      url: data.url || '',
      provider: data.provider || '',
      durationTotal: data.durationTotal || 0,
      progress: data.progress || 0,
    },
  },
});
